/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { CreateMemberDto } from './create-member-dto';
import { CreateUserEvaluationSurveyDto } from './create-user-evaluation-survey-dto';
import { CreateUserMobilityDto } from './create-user-mobility-dto';
import { CreateUserPathologyDto } from './create-user-pathology-dto';
import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface TriageMemberDto
 */
export interface TriageMemberDto {

    /**
     * @type {CreateMemberDto}
     * @memberof TriageMemberDto
     */
    member: CreateMemberDto;

    /**
     * @type {Array<CreateUserPathologyDto | JoinEntityDto>}
     * @memberof TriageMemberDto
     */
    pathologies?: Array<CreateUserPathologyDto | JoinEntityDto>;

    /**
     * @type {Array<CreateUserEvaluationSurveyDto>}
     * @memberof TriageMemberDto
     */
    surveys?: Array<CreateUserEvaluationSurveyDto>;

    /**
     * @type {CreateUserMobilityDto}
     * @memberof TriageMemberDto
     */
    mobility?: CreateUserMobilityDto;
}
